export default {
  bank_product: {
    complete_msg:
      'Agradecemos sinceramente por <span>assinar o produto</span> e recompensá-lo com um produto melhor.',
  },
  enter_amount: 'Por favor, insira o valor.',
  reg_complete: 'Registro concluído',
  subscription_details: 'Detalhes de assinatura',
  select_withdrawal_account: 'Selecione a conta de retirada',
  email_address: 'Endereço de email',
  product_info: 'Informação do produto',
  new_amount: 'Nova quantia',
  min_running_amount: 'Quantidade mínima de execução ',
  max_running_amount: 'Quantidade máxima de execução ',
  product_type: 'Tipo de Produto',
  bank_product_name: 'Nome do Produto',
  reg_start_date: 'Data de início do registro',
  reg_end_date: 'Data de término da assinatura ',
  exec_start_date: 'Data de início de execução ',
  exec_end_date: 'Data de término da execução ',
  basic_info: 'Informação básica',
  not_applicable: 'Não aplicável',
  subscription: 'Junte-se',
  service_prepare: 'O serviço está sendo preparado.',
  no_buy_list: 'Não há histórico de compras.',
  no_sell_list: 'Não há histórico de vendas.',
  no_list: 'Não há lista.',
  locale_name: 'Português',
  Sale_registration: 'Registro de venda',
  apply: 'aplicação',
  status: 'estado',
  wallet: 'carteira',
  wallet_address: 'Endereço da carteira',
  wallet_transfer: 'Transferência de carteira',
  buy: 'Comprar',
  sell: 'venda',
  all: 'Todos',
  breakdown: 'Repartição',
  act_buy: 'Comprar',
  act_sell: 'Comprar',
  asset: 'ativos',
  select: 'seleção',
  no_select: 'não selecionado',
  account: 'contas',
  balance: 'saldos',
  login: 'login',
  logout: 'sair',
  register: 'Participar como membro',
  select_cancel: 'Desmarque',
  cancel: 'cancelado',
  modify: 'cristal',
  auto_input: '(Entrou automaticamente)',
  confirm: 'confirmação',
  look_up: 'referência',
  password: 'senha',
  account_delete: 'secessão',
  detail: 'mais',
  list_detail: 'mais detalhes',
  birth: 'aniversário',
  welcome: 'Bem-vindo.',
  please_login: 'Por favor login.',
  confirmation_login: 'Você pode verificá-lo quando fizer login.',
  id: 'Nome de Usuário',
  find_id: 'Procurar ID',
  find_password: 'Esqueceu a senha',
  back: 'retorno',
  agreement: 'Termos do acordo',
  info_input: 'informações de entrada',
  success: 'completo',
  agree_msg: 'Concordo.',
  all_agree: 'Concordo com tudo',
  agree: 'Aceita',
  agreed: 'Acordado',
  confirm_password: 'Confirme a Senha',
  repeat_password: 'Confirme a Senha',
  next: 'Próximo',
  before: 'Volte',
  register_success: 'Registre-se agora.',
  verify: 'confirmação',
  retention: 'retenção',
  allow: '(Aceite)',
  disallow: '(Inaceitável)',
  upload_btn: 'Por favor soltar arquivos, ou clique aqui.',
  continue_entry:
    'Por favor, indique o seu: "[+:verification]" Para continuar abaixo.',
  login_msg_1: 'Coin relacionadas com contas Tente em COCOFX !',
  login_msg_2:
    'Através da nossa COCOFX utilize o negócio e carteiras e serviços.',
  login_msg_3: 'COCOFX pode suportar todos os ambientes.',
  cocofx_register: 'COCOFX Register',
  register_msg_1:
    'Participar como membro. <br /> Por favor, concorda com os nossos termos e condições',
  register_msg_3: 'Uma conta COCOFX dará acesso a todos os serviços à vontade.',
  register_msg_all:
    'O consentimento para todos inclui o consentimento para itens obrigatórios e opcionais, e você pode selecionar o consentimento individualmente. Mesmo se você se recusar a concordar com as opções, o serviço estará disponível.',
  register_title: 'Estou acima da idade de 19 e mais velhos.',
  register_title_2: 'Condições COCOFX',
  register_title_3: 'COCOFX Integração Termos de serviço',
  register_title_4: 'COCOFX comercialização alavancagem concordou',
  register_title_5: 'A coleta eo uso de informações pessoais consentimento',
  register_title_6: 'A coleta e uso de acordo informações de localização',
  register_title_7: 'Concordo informações de perfil adicionais a cobrar',
  register_title_8: 'Entrada COCOFX Informações da Conta',
  register_title_9: 'Informações de entrada',
  register_msg_4:
    'Esses termos se aplicam a todos os serviços prestados pela empresa. <br /> Ao concordar com estes termos, você pode usar esses serviços sem a assinatura de um contrato separado.',
  required: '[Requeridos]',
  option: '[Seletivo]',
  otp_notice: 'O estado é ativado e desativado OTP impossível.',
  required_check: 'Verifique todos os campos obrigatórios',
  check_input: 'Por favor, indique todos os detalhes.',
  register_guide: 'Como usar COCOFX',
  register_step1: 'Clique SHOPPAY Botão',
  register_step2: 'Entre para SHOPPAY',
  register_step3: 'Pagamento / Recharge SHOPPAY Sessão',
  copy: 'copiando',
  no_account: 'Há contas não registradas.',
  inviter_link: 'links de referência',
  register_used_account: 'Cadastre contas frequentemente utilizadas',
  security_certification: 'Certificação de segurança',
  admin_security: 'O nível de segurança para {action} é {limit}.',
  company: 'empresa',
  exact_calculation: 'ajuste',
  profile: 'Informações membro',
  inquiry: 'inquérito',
  announcement: 'notificações',
  information: 'informações',
  history: 'história',
  registration_date: 'Data de registro',
  pay: 'Forma de pagamento',
  detail_search: 'Full Text Search',
  more_view: 'Ver mais',
  exchange_store: 'troca',
  external_exchange_store: 'Troca externa',
  internal_exchange_store: 'Troca interna',
  external_transaction: 'Transação externa',
  internal_transaction: 'Transação interna',
  favorites: 'Favoritos',
  no_favorite_list: 'Não há favoritos.',
  no_alias: 'Sem alias',
  please_enter_account_name: 'Por favor, insira o nome da sua conta.',
  variable_amount: 'Quantidade variável',
  changes: 'Alterar',
  account_transaction_history_inquiry:
    'Consulta do histórico de transações da conta',
  exchange_application_completed: 'O pedido de câmbio foi concluído.',
  choose_how_pay_fee: 'Escolha como pagar a taxa',
  free: 'livre',
  closing: 'fechamento',
  relative_asset_inquiry: 'Consulta de ativos relativos',
  please_enter_relative_account_number: 'Insira o número da conta relativa.',
  Please_enter_relative_wallet_address:
    'Digite o endereço da carteira relativa.',
  memo: 'memorando',
  write_history_memo:
    'É conveniente gerenciar se você escrever um memorando de histórico.',
  re_enter: 'Reentrar',
  transfer_wallet_account: 'Endereço da carteira de transferência',
  transfer_wallet_inquiry: 'Consulta de carteira de transferência',
  Kiosk: 'Quiosque',
  withdrawable_amount: 'Montante a retirar',
  transferred_assets: 'Transferir ativos',
  recipient: 'Destinatário',
  recipient_wallet: 'Carteira do destinatário',
  register_user_name_tit:
    'Recomendamos que você preencha o nome real para a certificação de segurança.',
  register_password_tit:
    'Por favor, preencha o endereço de e-mail freqüentemente usado corretamente.',
  product_name: 'Nome do Produto',
  dividend_type: 'tipo de dividendo',
  auto: 'Automático',
  manual: 'manual',
  s_usdt_protocol: 'Escolha um protocolo Tether',
  ccf: {
    what_ccf: 'O que é CCF?',
    key_coin: 'A moeda-chave do SHOPPAY que conecta criptomoeda à moeda real',
    ccf_description:
      'É a moeda-chave do CocoBank que converte várias criptomoedas por meio de câmbio direto e transações C2C, e 1CCF tem um valor de US $ 1CENT. O CCF permite compras e transações mais rápidas e seguras no COCOFX.',
    how_use_ccf: 'Como usar o CCF?',
    cocobank_wallet_transfer:
      'Transfira ativos de criptomoeda armazenados em bolsas externas para a carteira do SHOPPAY.',
    ccf_conversion:
      'Converta a criptomoeda transferida para a carteira em CCF por meio de câmbio direto ou transação C2C.',
    direct_exchange_c2c_deal: 'Transação C2C de câmbio direto',
    ccf_moved: 'O CCF convertido será transferido para sua conta SHOPPAY.',
    how_use_account_ccf: 'O CCF transferido para a sua conta é usado assim!',
    freely_purchase_open_market:
      'Compre gratuitamente produtos de mercado aberto com CCF!',
    free_deposit_withdrawal:
      'Depósito e saque grátis e transferência entre contas dentro do banco!',
    exchange_currencies_convenient:
      'A troca entre moedas torna-se conveniente através da troca direta de moeda e transações C2C!',
    offline_convenient:
      'Use os serviços do SHOPPAY de forma mais conveniente, mesmo offline!',
    how_wallets_accounts_different: 'Como carteiras e contas são diferentes?',
    same_means_storing_cryptocurrency:
      'No SHOPPAY, carteiras e contas são os mesmos meios de armazenar criptomoedas, mas seu uso difere dependendo do tipo de transação (interna e externa) da criptomoeda. Em outras palavras, a carteira é usada em transações (externas) entre a bolsa e o SHOPPAY, e a conta é usada em transações (internas) no SHOPPAY.',
  },
  header: {
    certification_management: 'Certificação / Gestão',
    c2c_enroll: 'Compra / Venda',
    wallet_list: 'Carteira / História &',
    wallet: 'carteira',
    c2c_list: 'histórico de compras / vendas',
    no_c2c_sell_list: 'Não há histórico de vendas.',
    transfer_list: 'História Câmbios',
    no_transfer_list: 'Não há histórico de troca.',
    withdrawal_list: 'Entrada / História Retirada',
    my_info: 'minha Informação',
    home: 'Maine',
    payment_history: 'Histórico de faturamento',
    account_transfer: 'Transferência de conta',
    transfer_history: 'histórico de transferências',
    register_used_account: 'Cadastre contas frequentemente utilizadas',
    exchange: 'para troca',
    exchange_list: 'História Câmbios',
    email: 'E-mail',
    email_list: 'História e-mail',
    otp: 'OTP',
    otp_list: 'História OTP',
    register_account: 'conta de registo',
    calculation_account_list: 'Liquidação lista de contas',
    security_certification: 'Certificação de segurança',
    exact_calculation: 'ajuste',
    history: 'história',
    coco_open_market: 'COCO Open Market',
    information: 'informações',
    my_profile: 'minha Informação',
    email_modify: 'Editar e-mail',
    password_modify: 'Edite sua senha',
    inquiry: 'inquérito',
    inquiry_history: 'Detalhes de contato',
    one_on_one_inquiry: '1:1 inquérito',
    frequently_asked_questions: 'FAQ',
    announcement: 'notificações',
    notice: 'notificações',
    server_notice: 'anúncios de servidor',
    service_center: 'centro de serviço',
    profile: 'Informações membro',
    company: 'empresa',
    account_management: 'Gerenciamento de Contas',
    do_exchange: 'para troca',
    transfer: 'transferências',
    look_up: 'referência',
    faq: 'FAQ',
    server: 'servidor',
    email_request: 'e-mail Contacto',
    Product_Subscription: 'Produto e assinatura',
    easy_payment: 'Pagamento facilitado',
    easy_login: 'login fácil',
  },
  footer: {
    footer_msg: 'Aproveite as contas relacionadas com a moeda em COCOFX!',
    footer_sub_msg:
      'Através da nossa COCOFX utilize as transações e serviços de carteira',
    footer_sub_msg2: 'ponta',
    footer_sub_msg3: 'COCOFX pode suportar todos os ambientes.',
    ICO: 'ICO',
    c2c: 'C2C Troca',
    b2c: 'trocas B2C',
    margin_exchange: 'margem de câmbio',
    gift_exchange: 'bolsa de futuros',
    Binary: 'Opções binárias',
    open_marcket: 'Open Market',
    game: 'jogos',
    proceed: 'transações em andamento',
    public: 'IPO Notícias',
    direct_ex: 'troca direta',
    buy: 'Comprar',
    sell: 'Comprar',
    buy_sell: 'Compra / venda',
    holding_coin: 'segurando moeda',
    fee: 'Guia de taxa',
    exchange: 'troca',
    transfer_record: 'Histórico de negociação',
    Leverage: 'influência',
    live_exchange: 'ao vivo Negociação',
    demo_exchange: 'demo Trading',
    contest: 'rali',
    powerball: 'Powerball',
    law:
      'Legal: número de registo do COCOFX.COM: 70638826927 (U 6 29 Railway Pde EastwoodNSW 2122)',
    law1:
      'Negociação Ponto de Instrumentos Financeiros O proprietário de todo o Ltd (Austrália) é COCOFX PTY Ltd Número de registo: 70638826927 marca.',
    law2:
      'Este site é alimentado por COCOFX Corp. COCOFX Corp aprovado número 64.190 - estão sob a regulação do serviço de finanças Auxiliary, é registado no número de referência 70638826927 Austrália.',
    law3:
      'COCOFX opera de acordo com as diretrizes de investimento produtos financeiros australianos.',
    law4:
      'ref. não. 538324 | reg ABN. 70638826927 | reg BA. 64190. Para se certificar de que você está autorizado a utilizar os serviços COCOFX nas disposições legais do país de residência é da exclusiva responsabilidade do cliente.',
    law5: 'Por favor, leia a Divulgação de Risco profissional COCOFX.',
    law6:
      'não COCOFX não prestação de serviços aos Estados Unidos, Belize, Ilhas Maurícias, Japão, Alberta, British Columbia, Quebec, Saskatchewan Moradores de Saskatchewan, Haiti, Suriname, a Coreia do Norte, Porto Rico e da área ocupada de Chipre.',
    law7:
      'Por favor, consulte a parte reguladora do FAQ para mais informações. Consulte a nossa Divulgação de Risco.',
    law8:
      'As áreas restritas: se a Trading Point of Financial Instruments Ltd não fornece o investimento e serviços auxiliares para os países do terceiro mundo e regiões.',
    law_warn: 'Aviso de Risco:',
    law_1:
      'CFD tem um risco elevado e produtos complexos rapidamente perder seu dinheiro devido à alavancagem. 69,10% dos investidores individuais respondem ele vai perder dinheiro quando da negociação de CFD.',
    law_2:
      'Você deve considerar se você pode aceitar o fato de que você entenda o CFD funciona, maior o risco de perder dinheiro. Consulte a nossa Divulgação de Risco.',
    alert_title: 'Nota e nota',
    coco_market: 'COCO Mercado',
    ieo_market: 'IEO Mercado',
    news: 'Notícia',
    event: 'evento',
    platform_rental_title: 'aluguer de plataformas',
    education: 'Educação',
    online_Academy: 'Academia on-line',
    offline_Academy: 'Academia offline',
    shopping_basket: 'Cesta de compras',
    best_product: 'Melhores negócios',
    order: 'ordem',
    my_page_title: 'minha página',
    member_info_management: 'Gerenciamento de Contas',
    order_management: 'Order Management',
    my_question: 'minha pergunta',
    one_enquiry: '01:01 Contato',
    community: 'comunidade',
    lotto: 'Loteria Powerball',
    rock_event: 'rocha Evento',
    quiz_game: 'Trivia Game',
    ladder_game: 'Escada',
    tetris: 'Tetris',
    split_lotto: 'Lotto dividida',
    day_Lottery: 'loteria diária',
    attendance: 'verificação de atendimento',
    scoop_out: 'Embutir',
    forum: 'fórum',
  },
  main_msg: {
    about_1_title: 'O mundo melhor serviços de negociação de senhas moeda',
    about_1_msg: 'Todos os serviços, correspondente à moeda levando COCOFX.',
    about_1_1_msg:
      'Disponível para a primeira moeda criptomoeda tempo, as vendas em um único lugar no mundo.',
    about_1_2_msg: 'Quanto à troca direta está disponível a SHOPPAY.',
    about_2_title: 'Imediatamente sistema de troca',
    about_2_msg:
      'COCOFX usando uma tecnologia de combinação estáveis ​​multi-paralelo aplicar imediatamente as tecnologias de design avançado para habilitar o Exchange Stocks Exchange System.',
    about_3_title: 'carteira gerado',
    about_3_msg:
      'Os especialistas em segurança foram COCOFX é composta pelos melhores engenheiros na Coréia Equipado com sistema de segurança state-of-the-art fornece sistema de carteira.',
    about_4_title: 'sistemas de negociação simples (C2C)',
    about_4_msg:
      'COCOFX é construir um simples, sistema de negociação user-friendly Vamos permitir que uma transação mais conveniente.',
    c2c_main_msg1_1:
      'COCOFX irá trocar imediatamente, usando tecnologia de correspondência multi-paralelo confiável',
    c2c_main_msg1_2:
      'Segure o sistema de troca, aplicando as técnicas de design avançado para ativar e',
    c2c_main_msg1_3: 'Há sim.',
    c2c_main_msg2_1:
      'Os especialistas em segurança foram COCOFX é composta pelos melhores engenheiros na Coréia',
    c2c_main_msg2_2:
      'Equipado com sistema de segurança state-of-the-art fornece sistema Wallet.',
    c2c_main_msg3_1:
      'COCOFX é mais fácil de sistema de negociação user-friendly construção',
    c2c_main_msg3_2: 'Ele permite a fácil negociação.',
  },
  toasted_msg: {
    agree_required_term: 'Concorde com os termos e condições exigidos',
    must_read_term: 'Você deve ler ou baixar todos os termos e condições.',
    confirm: 'Ele foi identificado',
    changed: 'Mudanças foram',
    withdrawal: 'retirada foi',
    register: 'Foi registrado.',
    delete: 'Ele foi excluído.',
    title: 'notificações',
    exchange: 'troca direta foi processado com êxito.',
    search: 'Era visto.',
    deposit_request: 'Aplicação foi depositado.',
    withdraw_request: 'Retirada tem vindo a aplicar.',
    create_account: 'Ele foi aberto.',
    modify: 'Ele foi corrigido.',
    cancel: 'Ele foi cancelada.',
    trade_confirm: 'Negociação tenha sido estabelecida.',
    trade_reject: 'Negócio negado.',
    copy: 'Copiado.',
    nice_msg:
      'Se você não tem que ser desativado nas configurações do seu navegador pop-up de autenticação de identidade não procede normalmente.',
    nice_title: 'informações',
    nice_success: 'autenticação de identidade foi processado com êxito.',
    nice_error: 'Não é possível verificar a sua identidade.',
    no_transfer: 'Sem troca de informações.',
    email_auth: 'autenticação de e-mail é concluída com êxito.',
    email_auth_send: 'Este e-mail foi enviado para certificação.',
    kyc_withdraw: 'autenticação de conta foi bem sucedida.',
    not_allow_trade: 'Deal é inativo.',
    id_find_mail_send: 'ID foi enviado por e-mail.',
    duplicate_check: 'ID duplicado ou e-mail.',
    pay: 'O pagamento está completo.',
  },
  private: {
    deal_list: 'Histórico de vendas',
    app_list: 'histórico de compras',
    deal_buy_asset: 'Ativos a serem comprados',
    buy_price: 'preço de compra',
    confirmed_source_amount: 'Confirmar Vendas',
    holding_source_amount: 'Vendas não confirmados',
    potential_source_amount: 'Quantidade disponível',
    direct_market: 'troca direta',
    deal_enroll: 'vender',
    app_enroll: 'para Compra',
    select_market: 'Select Market',
    fee_rate: 'comissão',
    deal_info_input: 'Digite Informações de Vendas',
    deal_source_amount: 'de vendas',
    deal_price: 'Preço por unidade',
    deal_enroll_account: 'Conta para Vender',
    account_select: 'Selecione Conta',
    direct_asset_select: 'Por favor, escolha uma propriedade venda e compra',
    please_select_asset: 'Por favor, selecione um ativo.',
    basic_rate: 'preço atual',
    direct_transfer_buy: 'a compra imediata',
    direct_transfer_sell: 'Imediatamente no momento da venda',
    direct_source_amount: 'Unidade de câmbios',
    direct_target_amount: 'aplicar Quantidade',
    direct_asset_buy: 'Compre {0}',
    direct_asset_sell: 'As vendas para {0}',
    selected_deal_info: 'Informações de vendas selecionados',
    deal_source_asset_title: 'bens adquiridos',
    deal_total_source_amount: 'volume total de vendas',
    app_info_input: 'Digite Informações de compra',
    app_amount: 'volume de compras',
    app_deal_price: 'preço',
    pay_target_amount: 'Quantidade pago para fazer',
    fee: 'comissão',
    fee_calc: 'valor da taxa',
    msg_fee_calc: 'Como {0} será deduzido.',
    app_account: 'Conta de Compra',
    app_receive_account: 'Selecione a conta a receber',
    c2c_buy_select_asset: 'Por favor escolha uma compra de propriedade',
    go_home: 'Voltar à página',
    buy_calc_spread: 'Moeda de compra',
    sell_calc_spread: 'Moeda sell',
    cs_market_asset: 'ativos par',
    cs_market_basic_rate: 'taxa de referência de marketing',
    transfer_type: 'Tipo de câmbio',
    exchange_rate: 'taxa de câmbio',
    submit_transfer: 'trocarão imediatamente',
    deal_source_min_amount: 'A quantidade de compra mínima',
    closed_date: 'terminar um',
    no_deal: 'Nenhuma lista de vendas',
    app_price_per_quantity: 'Preço por Unidade',
    app_fee_amount: 'total de taxas',
    select_deal_app_list: 'Compras de vendas selecionados',
    no_select_deal_app_list: 'Não há compras em suas vendas',
    transfer_source_amount: 'Com base na quantidade de ativos',
    transfer_target_amount: 'Para os ativos Quantidade',
    transfer_basic_rate: 'taxa de referência aplicada a venda',
    transfer_spread_rate: 'spreads das taxas de aplicação',
    transfer_exchange_rate: 'taxa de câmbio',
    transfer_list_detail: 'Permuta Para mais detalhes',
    transfer_source_asset: 'Baseado em ativos',
    transfer_target_asset: 'para os ativos',
    transfer_source_account_number: 'Com base no número de conta de ativos',
    transfer_target_account_number: 'Para o número de conta de ativo',
    transfer_detail_type: 'Tipo de câmbio',
    transfer_regdate: 'Aplique uma',
    transfer_asset_info: '{0} a {1} {2}',
    transfer_asset_select:
      'Por favor, selecione o recurso que deseja substituir.',
    msg_transfer_buy: 'Compre {0}',
    msg_transfer_sell: 'As vendas para {0}',
    deal_fee_amount: 'Despesas de venda Divulgação partido impostas',
  },
  wallet_page: {
    have_asset: 'ativos',
    asset_list: 'Lista de Ativos',
    account_list: 'Lista de contas',
    account_create: 'criação de conta',
    deposit: 'depósito',
    withdraw: 'retirada',
    deposit_list_look: 'depósito Lookup',
    deposit_look: 'depósito Visualizações',
    withdraw_list_look: 'Retirada History &',
    withdraw_look: 'retirada Visualizações',
    account_modify: 'Modificar Conta',
    deposit_apply: 'Aplicação depósito',
    withdraw_apply: 'aplicação retirado',
    deposit_request_amount: 'Montante da caução',
    withdraw_request_amount: 'retirada Valor',
    withdraw_account_info: 'Retirada Informações da Conta',
    holder_name: 'Conta Detentor do Nome',
    bank_name: 'Nome do Banco',
    withdraw_bank_address: 'Número de conta',
    withdraw_address: 'endereço do imóvel',
    qr_address: 'endereço da conta',
    create_qr_address: 'Conta Discurso de Abertura',
    account_enroll: 'O registo da conta',
    account_seq: 'número de identificação da conta',
    account_title: 'Nome da conta',
    regdate: 'Gaeseolil',
    before_regdate: '(Antes de abertura)',
    holding_balance: 'Pare o montante',
    select_asset: 'Select propriedade',
    create: 'inaugurado',
    deposit_list: 'depósito',
    no_deposit_list: 'Não há detalhes do pedido de depósito.',
    deposit_apply_detail: 'Depósito Peça mais detalhes',
    asset_title: 'ativo',
    request_amount: 'montante solicitado',
    withdraw_list: 'História retirada',
    no_withdraw_list: 'Não há pedido de retirada.',
    withdraw_apply_detail: 'Retirada Peça mais detalhes',
    withdraw_fee_total_amount: 'Retirada total (incluindo taxas)',
    net_amount: 'valor final',
    fee_type: 'tipo de taxa',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: 'Conta Discurso de Abertura',
    deposit_msg:
      'Depositar minha carteira {0} {0} do lado de fora da carteira.',
    deposit_msg_1:
      'Uma vez aprovados 350 vezes (confirmação) na cadeia bloco {0} operações estão reflectidas na carteira.',
    deposit_step_1: 'Passo 1. Verifique a ID {0} memorandos em primeiro lugar.',
    deposit_step_1_1: 'Meu notas ID {0}',
    deposit_step_1_2:
      '{0} deve marcar suas próprias notas ID quando você deposita. {0}, sem notas de transferência de ID é perdido.',
    deposit_step_1_3: 'Veja o seu {0} endereço Wallet.',
    deposit_step_1_btn: 'Notes ID Copiar',
    deposit_step_2: 'Passo 2. Verifique se o seu endereço de carteira.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'carteira Endereço',
    deposit_step_2_3:
      'O depósito mínimo é <span style = "color:#4a90e2"> {0} {1} é </ span>.',
    deposit_step_2_btn: 'Bolsa Copiar endereço',
    deposit_msg_2: 'verifique',
    deposit_msg_2_1: 'Este é o endereço para o único depósito.',
    deposit_msg_2_2:
      'O tempo total necessário para se conformar conclusão pode ser afetado por congestionamento da rede de cadeia de bloco, criptomoeda estrelas Block encadeamento congestionamento é <span style = "color: #4a90e2; cursor: pointer;"> aqui </span> você pode verificar.',
    no_account_list: 'Não há lista de contas.',
    no_favorite_account_list: 'Não existe uma lista de contas favorita.',
    input_account: 'Por favor, insira o nome da sua conta para mudar.',
  },
  my_page: {
    my_profile: 'minha Informação',
    user_unique_num: 'Número de identificação de membro',
    user_name: 'nome de usuário',
    email_address: 'E-mail',
    register_regdate: 'desde',
    last_login: 'Último login em',
    auth_complete: 'certificado',
    not_auth: 'não certificada',
    expdate: 'expiração',
    act_auth: 'autenticação',
    realname_auth: 'autenticação de identidade',
    email_auth: 'autenticação de e-mail',
    otp_auth: 'autenticação OTP',
    enroll: 'inscrição',
    security: 'Nível de segurança',
    show_security: 'Ver Nível de Segurança',
    auth_withdraw_address: 'Autenticação Endereço retirada',
    apply_list: 'aplicar Histórico',
    password_modify: 'Edite sua senha',
    email_modify: 'Editar e-mail',
    account_block: 'Conta retirada',
    placeholder_old_password: 'Por favor, indique a sua senha antiga',
    placeholder_new_password: 'Por favor digite sua nova senha',
    placeholder_confirm: 'Por favor, indique mais uma vez',
    placeholder_password: 'Digite sua senha',
    placeholder_email: 'Insira um novo e-mail',
    mail_cert_list: 'Histórico aplicativo de e-mail',
    no_mail_list: 'Não há histórico da aplicação de e-mail.',
    nominee_detail: 'História do círculo phidicular',
  },
  kyc: {
    register_account: 'conta de registo',
    kyc_enroll: 'Os pedidos de autenticação KYC',
    kyc_enroll_2: 'KYC prova de endereço',
    kyc_enroll_3: 'KYC Razão para ajuste de 4 etapas para cima',
    auth: 'certificado',
    auth_code_send: 'Enviando o código de autenticação',
    auth_code: 'Código de autenticação',
    msg_auth_code: 'Digite o código de verificação dentro de 5 minutos.',
    type_title: 'Nome do tipo',
    withdraw_auth: 'Autenticação Endereço retirada',
    withdraw_auth_tit:
      'Um procedimento de autenticação de endereço objetivo para dedução externa. Por favor, registre a conta de destino e o endereço da carteira a serem comprados.',
    select_asset: 'Select propriedade',
    select_bank: 'Select Bank',
    holder_name: 'Conta Detentor do Nome',
    birth: 'data de 6 dígitos de nascimento',
    address: 'endereço do imóvel',
    withdraw_list: 'Retirada Conta História Aplicação',
    bank_name: 'Nome do Banco',
    withdraw_info: 'Retirada Informações da Conta',
    withdraw_complete: 'A propriedade já completou esta certificação.',
    regdate: 'adicionado',
    delete_withdraw_address: 'endereço de débito Changed',
    delete_success_address: 'O endereço retirada mudou.',
    kyc_cert_list: 'KYC História Aplicação',
    no_kyc_list: 'KYC há histórico aplicação.',
    no_kyc_withdraw_address_list:
      'Não há histórico de aplicação de conta de pagamento.',
    kyc_placeholder: 'Por favor, insira.',
  },
  otp: {
    enter_verification_number: 'Insira um número de autenticação OTP',
    otp_auth: 'autenticação OTP',
    authenticode: 'Chaves OTP',
    otp_deactivate: 'OTP com deficiência',
    msg_authenticator_installation:
      'O app "Google Authenticator", por favor instalar em seu smartphone ou no seu desktop',
    android: 'andróide',
    or: 'ou',
    iphone_series: 'iPhone, iPad e iPod',
    windows_phone: 'Windows Phone',
    and: 'e',
    msg_microsoft_other_systems:
      'Outros sistemas, incluindo área de trabalho Microsoft Windows',
    msg_key: 'a chave',
    msg_use_loss_change:
      'Por favor, escreva no papel. Perdeu ou terminal é usado quando você precisa mudar o OTP.',
    msg_brcode_touch:
      'Execute o aplicativo "Google Authenticator" Preços Por favor, tocando no <b> Verificar QR código de barras </ b> na parte inferior da tela.',
    msg_input_authenticode:
      'Digite o código de verificação exibido na tela do terminal no "Código de Autenticação" abaixo.',
    otp_key: 'Chaves OTP',
    otp_activate: 'activação OTP',
    otp_copy: 'As chaves de OTP copiado.',
    otp_safe_keeping:
      'Menos então fez a chave OTP em papel e armazená-lo em um lugar seguro?',
    yes: 'quatro',
    otp_register: 'inscrição',
    otp_register_success: 'O registro OTP foi concluída com êxito.',
    otp_delete_success: 'cancelamento OTP do registro é concluído com êxito.',
    msg_click_key_copy: 'Clique na chave copiada.',
    otp_login: 'Entrada OTP',
  },
  security: {
    show_security: 'Ver Nível de Segurança',
    grade: 'classificação',
    condition: 'condição',
    restriction: 'limitações',
    no_grade: 'Mudeunggeup',
    no: 'qualquer',
    security_title:
      'Limitações critérios de classificação de segurança específicas',
    banner1: 'Segurança confiável',
    banner2:
      'Para a compra ou venda através SHOPPAY, SHOPPAY deve garantir a criptografia de dados, monitoramento de transações em tempo real, a política de proteção de comprador e vendedor, e todos os seus pagamentos através de um SHOPPAY recebeu seguro de checkout e pagamento esquema.',
    banner_invite: 'SHOPPAY não tem uma conta?',
    banner_join: 'Registre-se Gratuitamente',
    banner3: 'Como SHOPPAY é manter nossos clientes seguros',
    content1_h3: 'Buyer Protection',
    content1_text:
      'Se o comprador ohbaesong desgaste ou danos mibaesong, SHOPPAY pode compensar o valor do pagamento total, incluindo custos de envio para as operações elegíveis. *',
    content2_h3: 'Vendedor de Proteção',
    content2_text:
      'Se você receber um pagamento não autorizado ou reivindicações mibaesong contra o vendedor na venda são elegíveis, você pode receber o valor integral de proteção. *',
    content3_h3: 'Criptografia de dados',
    content3_text:
      'conexões TLS, HTTPS para ajudar a manter o pagamento, a chave pinagem de aplicativos móveis, a conformidade PCI mais seguro.',
    content3_btn: 'PCI Compliance',
    content4_h3: 'Prevenção de fraude',
    content4_text:
      'Todas as transações são monitoradas em tempo real, através da análise de sua conta e suporte para evitar atividades fraudulentas e faturamento.',
    sec_h2: 'Cheque Compre',
    sec_text:
      'SHOPPAY porque a transação monitoramento 24 horas por dia, 365 dias quando detecta diferente algo de costume entrar em contato com o comprador pede-lhe para confirmar o seu login ou compra. Também verifica SHOPPAY para todas as compras e vendas via e-mail.',
    wran_h2: 'Se você encontrar alguns pontos suspeitos',
    warn_step1: 'Relatório.',
    warn_step1_text1:
      'Depois de confirmar os detalhes não tenham encontrado um acordo aprovado',
    warn_step1_text2:
      'Comunicar um problema> relatório de actividade não autorizada',
    warn_step1_text3: 'Clique ou contato imediatamente SHOPPAY.',
    warn_step2: 'Verifique se há outros problemas.',
    warn_step2_text1:
      'Comente definições recentes de atividade comercial e da conta para se certificar de que os encargos adicionais ou alterações, por favor, também relatar essas informações.',
    warn_step3: 'Por favor, altere sua senha.',
    warn_step3_text1:
      'Pode nas configurações da conta no menu Segurança. Ou, se você não conseguir fazer login na sua conta',
    warn_step3_text2: 'Login> logging Problemas',
    warn_step3_text3: 'Clique para obter reiniciado.',
    warn_btn: 'Relatar transações não autorizadas',
    online_h2: 'suportes SHOPPAY seguros atividades online.',
    online_h3: 'Segurança da conta',
    online_text: 'Proteger a sua conta com uma senha altamente segura.',
    online_btn: 'Saiba mais',
    auth_incomplete: 'Certificado incompleto',
  },
  input: {
    id: 'ID de entrada',
    password: 'uma senha de entrada (8-32 dígitos com caracteres especiais)',
    repeat_password: 'Confirme a Senha',
    user_name: 'Nome de usuário de entrada',
    email_address: 'E-mail de entrada de endereço',
  },
  oauth: {
    contact_msg: 'Quer acesso às seguintes informações no aplicativo {0}.',
    agree_msg: '{0} Você concorda que o acesso a {1} `s informações pessoais?',
    agree_info:
      'A informação fornecida será utilizada / guardada por um período de serviço para a identificação do usuário, estatísticas, contas vinculadas CS e similares. Informações básicas e fornecer os itens necessários são as informações que devem ser fornecidas para usar os serviços COCOFX.',
    agree_request: 'ofertas',
    agree_msg2:
      'Uma vez acordado, a informação será gerido em conformidade com os Termos e Condições e da Política de Privacidade do serviço.',
    agree: 'para concordar',
  },
  pay_head_foot: {
    account_management: 'Gerenciamento de contas',
    settlement_account_list: 'Lista de contas de liquidação',
    account_summary_views: 'Resumo da conta Visualizações',
    fund: 'fundos',
    history: 'Histórico de faturamento',
    help: 'Ajuda',
    qa: 'Fale conosco',
    fee: 'comissão',
    secure: 'segurança',
    go_shop: 'compras',
    my_info: 'meu perfil',
    my_page: 'Configurações de conta',
    out: 'sair',
    in: 'login',
    about: 'sobre',
    blog: 'Blogs',
    employ: 'Jobs',
    site_map: 'Mapa do site',
    developer: 'revelador',
    partner: 'parceiro',
    privacy_state: 'política de Privacidade',
    usage: 'Termos de Uso',
    feed_back: 'feedback',
    warn_to_consumer:
      'Notificação aos clientes: os proprietários dos meios pré-pagos de pagamento SHOPPAY ⓒ SHOPPAY não requer a aprovação da Autoridade de Supervisão Financeira da Austrália. Por favor, leia atentamente os termos e condições.',
  },
  continue: 'continuação',
  pay_home: {
    cocobank_title: 'COCO Banco',
    platform: 'plataforma',
    platform_rental: 'alugar plataformas',
    cocopay_is: 'SHOPPAY é o crescimento do negócio',
    help: 'Ajudando.',
    home_banner_1:
      'Ampliando a base de clientes potenciais em todo o mundo, e para facilitar a gestão de pagamentos,',
    home_banner_2:
      'Negócios Vendedor de Proteção *, e permitir seguro comprar na monitoramento 24/7 fraude.',
    home_banner_3: 'Você pode mais facilmente ter sucesso.',
    home_banner_warn:
      '* Termos e Condições aplicam-se ao vendedor de protecção. Por favor, consulte o seu contrato para obter detalhes sobre a elegibilidade.',
    home_banner_join: 'Registre-se grátis.',
    home_sec1_openShop: 'Você pode abrir uma loja em SHOPPAY.',
    home_sec1_btn: 'para lidar',
    home_sec2_h2: 'Obter o método de pagamento desejado.',
    home_sec2_text1:
      'SHOPPAY também pode receber pagamentos on-line, móvel, e até mesmo e-mail.',
    home_sec2_text2:
      'Se o SHOPPAY vendidos em qualquer lugar que pode ajudar com o pagamento mais fácil e mais seguro.',
    home_sec2_online_pay: 'Pagamento online',
    home_sec2_online_text:
      'botões de pagamento para facilitar o conjunto disponível SHOPPAY é muito útil quando receber pagamentos em dinheiro e pagamentos periódicos, doações, etc. Com SHOPPAY Caixa, os clientes podem fazer pagamentos mais rápida e facilmente.',
    home_sec2_online_more: 'Veja sobre o pagamento on-line',
    home_sec2_voice_invoice: 'email fatura',
    home_sec2_voice_text:
      'solicitação de e-mail fácil para pagamento ao profissional gratuita a factura. clientes no exterior, bem como estão disponíveis para clientes que não são da conta SHOPPAY.',
    home_sec2_voice_more: 'Veja mais sobre faturas de e-mail',
    home_sec2_exchange_pay: 'Efetue um pagamento na bolsa',
    home_sec2_exchange_text:
      'Com o serviço de carteira integrado na central, você pode recarregar, comprar e vender moedas em qualquer central de empresas parceiras.',
    home_sec2_exchange_more: 'Saiba mais sobre cobrança de câmbio',
    home_sec2_mobile_pay: 'Obter pagamentos móveis',
    home_sec2_mobile_text:
      'As soluções são automaticamente otimizadas para celular. Obter mundo onde ainda mais fácil de pagar através do site móvel ou as aplicações Android e iOS.',
    home_sec2_mobile_more: 'Veja mais sobre pagamentos móveis',
    home_sec3_h2: 'Encontre mais trabalho com parceiros SHOPPAY freelance.',
    home_sec3_global:
      'SHOPPAY vai ligar as oportunidades mais globais com os principais sites independentes do mundo.',
    home_sec3_btn: 'Verificando SHOPPAY para freelance',
    home_sec4_h2: 'É fácil começar.',
    home_sec4_banner1:
      'Saiba tudo o que você precisa para começar a partir de centro de negócios SHOPPAY.',
    home_sec4_banner2:
      'Junte-se à conta de negócios e verificar o seu endereço de e-mail',
    home_sec4_banner3: 'Certificado para a conta bancária',
    home_sec4_banner4: 'Selecione uma solução de pagamento',
    home_sec5_h2:
      'Por que o mundo muitas operadoras <br/>fazem SHOPPAY confiança.',
    home_sec5_sub_text:
      'Porque é uma excelente escolha. SHOPPAY você gostaria de conectar o vendedor com 25 chamadas para o cliente pelo menos dois cem milhões de pessoas em mais de 200 mercados em todo o mundo.',
    home_sec5_sub_text_1: 'Porque é uma excelente escolha.',
    home_sec5_sub_text_2:
      'SHOPPAY você gostaria de conectar o vendedor com 25 chamadas para o cliente pelo menos dois cem milhões de pessoas em mais de 200 mercados em todo o mundo.',
    home_sec5_h3: 'Segurança.',
    home_sec5_h3_sub1:
      'determinar automaticamente scam, transações monitoramento 24 horas e o programa de proteção vendedor e comprador para proteger o seu negócio e seus clientes.',
    home_sec5_h3_more: 'Veja mais sobre o pagamento on-line',
    home_sec5_h31: 'O mundo usa.',
    home_sec5_h31_sub1:
      'Em todo o mundo, sem a necessidade de digitar as informações cada vez que fizer um pagamento rapidamente. Em 203 mercados em 26 moedas você pode pagar via cartão de crédito, cartão de débito ou SHOPPAY.',
    home_sec5_h31_more: 'Veja mais sobre faturas de e-mail',
    home_sec5_h32: 'Rápido.',
    home_sec5_h32_sub1:
      'Na maioria dos casos, quando um pagamento do cliente é imediatamente creditado na sua conta SHOPPAY. banco debitado ou um pagamento para o fornecedor ou o uso livremente em qualquer lugar onde o pagamento SHOPPAY possível.',
    home_sec5_h32_more: 'Veja mais sobre eBay venda',
    home_sec6_h2: 'estrutura de taxas simples',
    home_sec6_sub:
      'SHOPPAY irá cobrar uma taxa somente quando as vendas feitas. taxas SHOPPAY são corrigidos com base na localização do cliente e da quantidade de vendas.',
    home_sec6_more: 'Veja mais sobre taxas',
    home_sec7_h2: 'Comunidade para a Coreia do Sul venda, LAB CBT',
    home_sec7_text1:
      'Instituto comércio transfronteiriço (CBT LAB) é uma comunidade comerciante SHOPPAY Coreia (Coreia do SHOPPAY) patrocinado para o exterior e-commerce habilitado.',
    home_sec7_text2:
      'CBT LAB está ajudando o negócio crescer compartilhar informações globalmente Costa Leste, como as últimas tendências, dicas e melhores práticas.',
    home_sec7_more: 'Saiba como tirar proveito da CBT LAB',
    home_sec8_h2: 'Conheça os parceiros interligados SHOPPAY.',
    home_sec8_text1: 'Precisa de ajuda profissional para o seu negócio online?',
    home_sec8_text2:
      'Soluções de hospedagem web, carrinho de compras, soluções de comércio eletrônico, tais como obras de avanço SHOPPAY um parceiro comprou esta ajuda o seu negócio.',
    home_sec8_text3: 'Encontrar SHOPPAY um parceiro para o meu negócio agora.',
    home_sec8_more: 'mais Partners',
    home_sec9_h2: 'Torne-se um vendedor global. Isto irá SHOPPAY juntos.',
    home_sec9_h2_1: 'Torne-se um vendedor global.',
    home_sec9_h2_2: 'Isto irá SHOPPAY juntos.',
    home_sec9_btn: 'Inscreva-se para uma conta agora',
    home_learn_h2: 'Saiba mais',
    home_learn_li1: 'Solução Web Pagamento',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: 'SHOPPAY Caixa',
    home_learn_li1_3: 'Comprar no eBay',
    home_learn_li1_4: 'Soluções comparar',
    home_learn_li2: 'outros pagamentos',
    home_learn_li2_1: 'faturas de e-mail SHOPPAY',
    home_learn_li2_2: 'mobile Commerce',
    home_learn_li2_3: 'Negócios para pagamentos automáticos',
    home_learn_li2_4: 'SHOPPAY para B2B',
    home_learn_li2_5: 'SHOPPAY para freelance',
    home_learn_li3: 'configuração e integração SHOPPAY',
    home_learn_li3_1: 'centro de negócios SHOPPAY',
    home_learn_li3_2: 'SHOPPAY Coreia comunidade comerciante (CBT LAB)',
    home_learn_li3_3: 'Adicionar SHOPPAY SHOPPAY ao site',
    home_learn_li3_4: 'Confira Melhor Guia Set',
    home_learn_li3_5: 'revelador',
    home_learn_li3_6: 'parceiro',
    home_learn_li3_7: 'como SHOPPAY',
    home_learn_li4: 'Gerenciar Minha Conta',
    home_learn_li4_1: 'aplicativos de negócios SHOPPAY',
    home_learn_li4_2: 'Configurações da conta de negócios',
    home_learn_li4_3: 'Programa de proteção ao vendedor',
    home_learn_li4_4: 'Gerir reclamações de clientes',
    home_learn_li4_5: 'Chargebacks Entendimento (Chargeback)',
    home_learn_li4_6: 'restrições de conta Compreensão',
    home_learn_li4_7: 'Dicas de Prevenção de Fraude',
    home_learn_li4_8: 'PCI Compliance',
  },
  pay_nav: {
    view_your_account: 'Ver toda a sua conta',
    account_summary_views: 'Resumo da conta Visualizações',
  },
  pay_login: {
    secure_sub_title: 'Login e Segurança',
    secure_my_profile: 'meu perfil',
    secure_update_complete:
      'O perfil e as configurações ambiental foram atualizados.',
    secrue_suggest: 'Sempre que você nos contar a sua experiência.',
    search: 'recuperação',
    my_info: 'Informações pessoais',
    update: 'atualizar',
    e_mail: 'E-mail',
    default: 'informação básica',
    call: 'telefone',
    phone: '(Móvel)',
    pay_mobile: 'mobile Payment',
    trading: 'Troca de idéias',
    password: 'senha',
    change: 'mudança',
    secure_qa: 'Pergunta de segurança',
    staying: 'Mantenha-me conectado para compras mais rápidas',
    edit: 'compilação',
    browse_manage:
      'Gerenciar o dispositivo selecionado eo navegador para manter o estado de login.',
    account_type: 'Tipos de conta',
    account_delete: 'conta Cancelamento',
    business: 'negócio',
    edit_email: 'Editar endereço de email',
    change_email: 'Mudança de Endereço de Email',
    update_email: 'Adicione o seu e-mail',
    eamil_url: 'E-mail',
    update_email_url: 'Adicione o seu endereço de e-mail',
    error_email: 'Desculpe. O padrão de e-mail não pode ser editado.',
    confirm_new_email: 'Verificar novo endereço de e-mail',
    change_mail: 'Alterar e-mail',
    confirm: 'confirmação',
    changing: 'mudança',
    deleting: 'eliminação',
    reaming:
      'Atualmente dois do endereço de email associado à sua conta. Você pode adicionar mais de 5 e-mail.',
    qa_1: 'Qual é o nome da escola participou pela primeira vez?',
    qa_2: 'Qual é o nome do primeiro animal de estimação?',
    edit_phone: 'Editar um número de telefone existente',
    korea: 'República da Coreia',
    explanation:
      'Ao adicionar o número, eu confirmar que concorda para discar automaticamente e receber chamadas pré-gravados e texto, dependendo do motivo para a autoridade para adicionar dois números estão descritos na Política de Privacidade. taxas normais podem ser aplicadas.',
    edit_phone_num: 'número de telefone Alterar',
    edit_password: 'Change Password',
    confirm_password: 'Verifique a sua senha atual',
    new_passod: 'nova senha',
    confirm_password_new: 'Confirmar Nova Senha',
    secure_question: 'Pergunta de segurança',
    secure_pick: 'perguntas de escolha',
    secure_answer: 'resposta',
    edit_browse:
      'Com SHOPPAY One Touch você pode rapidamente completar o pagamento sem ter que logar-se cada vez.',
    already_log: 'O logado na máquina.',
    off_all: 'SHOPPAY One Touch off em todos os seus dispositivos',
    support:
      'PayPal está comprometida com a satisfação do cliente 100%. Se você tem um problema com sua conta',
    support_center: 'Suporte ao cliente',
    support_text1: 'Ou verificar o',
    support_text2: 'Por favor, consulte.',
    support_warn:
      'Se você cancelar a sua conta, você não pode cancelar seus registros de contas também irá desaparecer e níveis de confiabilidade.',
  },
  help: {
    support_center: 'apoio',
    resolution_center: 'Resolução de Conflitos Centro',
    qa_search: 'Pesquisar Perguntas Frequentes',
    common_qa: 'questões gerais',
    common_qa_1:
      'O `Por que é uma mensagem de erro é exibida após a atualização do status do seu pedido através dos obter fundos links?',
    common_qa_2: 'Como faço para retirar fundos da conta Coreia do SHOPPAY?',
    common_qa_3:
      'Como faço para adicionar um cartão de débito ou cartão de crédito à minha conta SHOPPAY?',
    common_qa_4:
      'SHOPPAY Esqueci minha senha da conta. Como faço para redefinir minha senha?',
    common_qa_5: 'Posso já cancelar enviou pagamento montante SHOPPAY?',
    common_qa_6: 'Como faço para receber pagamentos através SHOPPAY?',
    common_qa_7: 'Como faço para enviar o pagamento via SHOPPAY?',
    common_qa_8:
      'Como faço para adicionar uma conta bancária para a conta SHOPPAY?',
    common_qa_9:
      'Como posso verificar a conta bancária associada à minha conta SHOPPAY?',
    common_qa_10: 'Como faço para desativar o limite de conta SHOPPAY?',
    technical_support: 'Inscrever-se para questões técnicas e atualizações.',
    condition_cocopay: 'estado de exibição SHOPPAY',
    muliple_help: 'Mais maneiras de obter ajuda',
    trading_help: 'Para resolver tais problemas negócio',
    tex_center: 'Centro de imposto',
    tex_help: 'Encontrar formas de impostos e outros recursos',
    need_help: 'Fale conosco',
    help_center: 'Fale com o Suporte ao Cliente',
    help_to_center: 'Fale com o Suporte ao Cliente',
    prepare: 'Em breve.',
    fast_help:
      'Conte-nos o seu problema para que possamos mais rapidamente ajuda SHOPPAY.',
    my_search: 'Procurar meu problema',
    common_problem: 'Problemas comuns',
    login_problem: 'problemas de login',
    unkown_charge: 'acesso não autorizado ou dívidas desconhecidas relatório',
    send_money: 'Enviar dinheiro',
    get_fund: 'receber dinheiro',
    withdraw_money: 'retirar dinheiro',
    pay_cancel: 'Pagamento ou cancelar ordem',
    pay_hold: 'Pagamento pendente ou à espera',
    refund: 'reembolsos',
    pre_pament: 'pagamentos pré-aprovados',
    negative_balance: 'saldo negativo',
    account_qa_1:
      'SHOPPAY retirar minha conta o estado que ele mostra como "concluída" Por que é dinheiro que não contém uma conta bancária?',
    account_qa_2:
      'Qual é a razão da minha SHOPPAY retirada ainda é um status "pendente"?',
    account_qa_3: 'Por que a minha retirada pendente?',
    item_title: 'Senha de acesso e Conta',
    item_title_2: 'Conta Perfil & Definições',
  },
  business: {
    no_trade: 'Não há mercados de câmbio possíveis.',
    view_your_account: 'Ver toda a sua conta',
    available: 'disponível',
    calculate_late:
      'Vamos exibir o ativo atual do campo elétrico CCF mais importante.',
    payment_transfe: 'As transferências de pagamento',
    exchange: 'câmbio',
    currency_update: 'Incluir chamada',
    update_btn: 'botão de adição',
    currency_cal: 'conversor de moeda',
    pay_default: 'Preferências de pagamento',
    payment_send: 'Enviar ou pedido de pagamento',
    account_list: 'Lista de contas',
    no_alias: 'não há aliases',
    new_bank: 'Conecte o novo banco',
    card: 'cartão',
    new_card: 'Conecte o novo cartão',
    credit: 'crédito',
    preference_payment:
      'Escolha os seus métodos de pagamento online preferenciais.',
    payment_tip:
      'Ao fazer compras on-line ou enviar o pagamento de bens e serviços que utilizam este meio. Você pode a qualquer momento escolher um método de pagamento diferente durante o checkout.',
    payment_more: 'Aprender sobre suas preferências de pagamento',
    paymnet_changes: 'equilíbrio SHOPPAY',
    debit_card: 'Cartão de débito',
    currency_tip:
      'Se você adicionar uma moeda, todos os pagamentos futuros recebidos nessa moeda serão creditados aos fundos apropriados. A moeda base é usado para enviar um pagamento de pagamento ou solicitação.',
    currency_1: 'dólar australiano',
    currency_2: 'Franco suíço',
    currency_3: 'Coroa checa',
    currency_4: 'Coroa dinamarquesa',
    currency_5: 'euro',
    currency_6: 'libra inglesa',
    currency_7: 'Dólar de Hong Kong',
    currency_8: 'Forint',
    currency_9: 'Novo shekel israelense',
    currency_10: 'Peso mexicano',
    currency_11: 'Noruega Krone',
    currency_12: 'Dólar da Nova Zelândia',
    currency_13: 'Peso filipino',
    currency_14: 'Zloty polonês',
    currency_15: 'Rublo russo',
    currency_16: 'Coroa sueca',
    currency_17: 'Dólar de Singapura',
    currency_18: 'baht',
    currency_19: 'New dólares de Taiwan',
    withdraw_account: 'Conta retirada',
    exchanged: 'Depois de câmbio',
    exchange_rate: 'Taxas de câmbio',
    exchange_tip:
      'A taxa de câmbio é um valor estimado com base na taxa de câmbio atual, a taxa de câmbio está incluído no SHOPPAY.',
    currency_default: '(A) O iene japonês está definido para a moeda padrão.',
    currency_default_notice:
      'A moeda base é usado para enviar um pagamento de pagamento ou solicitação.',
    currency_default_notice2:
      'Fechando a chamada não é exibido sobre o saldo não recebe qualquer pagamento à chamada.',
    currency_default2: 'JPY (s), o padrão',
    currency_quit_jp_btn: 'Fechar Dólares',
    currency_quit_btn: 'Close call',
    bank_account: 'contas',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'saldos',
    bank_account_check: 'confirmando Banco',
    bank_account_remove: 'Excluir Banco',
    bank_continue: 'Você gostaria de continuar?',
    bank_tip:
      'Pendentes transações com os bancos são processados ​​após a exclusão.',
    bank_this_delete: 'Excluir Banco',
    card_tip:
      'A conta SHOPPAY quiser usá-lo sem gastar ou limites de retirada?',
    card_confirm: 'Verifique o cartão.',
    card_type: 'tipo',
    expiry_date: 'expiração',
    card_adress: 'Endereço de Cobrança',
    card_update: 'cartão de Atualização',
    card_delete: 'cartão de exclusão',
    card_this_delete: 'cartão de exclusão',
    card_tip2:
      'Este método de pagamento é actualmente preferido. Após a conclusão, você pode definir um método preferido de pagamento diferente. Negócio está pendente com (um) indeterminado é tratado após a eliminação.',
    secure_code: 'Código de segurança',
  },
  shop: {
    shop_list: 'loja Lista',
    shop_create: 'Loja criado',
    shop_cre_date: 'adicionado',
    shop_title: 'Nome da loja',
    shop_id: 'Código da loja',
    shop_state: 'estado',
    shop_work: 'trabalho',
    shop_detail: 'mais',
    shop_retouch: 'cristal',
    shop_settlement: 'Liquidação lista de contas',
    shop_history: 'transações',
    no_shop_list: 'Não há lista de lojas',
  },
  merchant: {
    create: 'loja inscrição',
    update: 'inscrição',
    retouch: 'lojas modificado',
  },
  pay_legal: {
    service_usage: 'SHOPPAY Termos de serviço',
    detail_usage:
      'Estes Termos e Condições será aplicada para a Ásia-Pacífico, América Latina e alguns países da Europa, Oriente Médio e utilizadores africanos. Para ver os termos e condições para diferentes países ou regiões, escolha da lista abaixo.',
    nation: 'Selecione um país',
    every_consumer: 'Todos os usuários',
    service_agree: 'O seu contrato para a SHOPPAY Serviço',
    privacy_state: 'política de Privacidade',
    purpose_policy: 'SHOPPAY Política de Uso',
    payment_agreement: 'SHOPPAY acordo método de pagamento alternativo',
    sell_buy: 'Merchant e Negócios',
    shop_policy: 'Políticas SHOPPAY Suporte Loja',
    contract_profit: 'Contrato de empresa com fins lucrativos',
    billing_agreement: 'Contrato de faturamento',
    direct_debit_agreement: 'fundos SHOPPAY recebidos e acordos de débito',
    additional_info: 'Informações adicionais',
    infringement: 'Somyeongseo violações de políticas',
    policy_update: 'Atualizações política',
    warn1:
      'Notificar os consumidores: serviço de pagamento SHOPPAY é considerado como um meio pré-pagos de pagamento (valor armazenado Facility) de acordo com a lei australiana.',
    warn2:
      'SHOPPAY os proprietários dos meios pré-pagos de pagamento ⓒ SHOPPAY não requer a aprovação da Autoridade de Supervisão Financeira da Austrália. Nós também incentivar os consumidores (usuários) são lidas atentamente estes Termos e Condições.',
    warn3:
      'Estes Termos de Uso e Avisos fornecer os termos e condições associados a um determinado serviços SHOPPAY.',
  },
  pay_privacy: {
    effective_day: 'Data de Vigência: 28 de março, 2019',
    summary: 'resumo',
    personal_data: 'Os dados pessoais recolhidos pela SHOPPAY',
    personal_date_cause: 'Razões manter seu SHOPPAY dados pessoais',
    summary_1: 'Nossos usuários são',
    summary_2: 'Sites',
    summary_3: 'ou visita',
    summary_4: 'serviço',
    summary_5: 'Ao usar do usuário',
    summary_6: 'Os dados pessoais',
    summary_7:
      'Como coletar e armazenar, gerenciar e compartilhar, explicando que a transferência preparou esta Política de Privacidade. Esta Política de Privacidade aplica-se a seus dados pessoais quando visita o nosso site ou usar o serviço, outra SHOPPAY',
    summary_8: 'usuário',
    summary_9:
      'Ela não se aplica a sites ou SHOPPAY web on-line não são de propriedade ou ajustes, incluindo local de serviço ou serviço.',
    summary2_1:
      'SHOPPAY você pode visitar nossos sites ou coletar informações pessoais quando você usa os seguintes tipos de serviços.',
    summary2_2: 'Use cima e Informação',
    summary2_3:
      'Quando você se inscrever uma conta para usar os serviços de SHOPPAY, para atender as informações necessárias para recolher dados pessoais, a fim de fornecer o serviço solicitado pelo usuário.',
    summary2_4:
      'Dependendo dos serviços selecionados, você pode pedir para fornecer as informações de identificação necessários para criar um nome de usuário, endereço, número de telefone, endereço de e-mail, conta.',
    summary2_5:
      'Termos que você pode pedir para fornecer dados pessoais adicionais, dependendo do serviço.',
    summary3_1: 'experiências e informações negociação',
    summary3_2:
      'Usando os serviços de SHOPPAY ou se o acesso ao site, por exemplo, comprar do vendedor, ou recebimento de dinheiro ou se o processamento de um dinheiro do pagamento ou enviar para amigos e familiares, recolher outras informações relacionadas negociação, bem como informações sobre a transação de SHOPPAY a. Outras informações trade-relacionada inclui o envio ou solicitar dinheiro, bens ou serviços de pagamento dinheiro, o vendedor, incluindo informações sobre todos os métodos de pagamento usados ​​para completar as informações informações de transação e dispositivo, os dados de tecnologia, informações de localização, e similares.',
    summary4_1: 'Informações do participante',
    summary4_2:
      'Quando você usa ou o acesso ao serviço local SHOPPAY recolhe dados pessoais que os usuários fornecem sobre outros participantes envolvidos no negócio.',
    summary4_3: 'Para enviar ou pedido de dinheiro',
    summary4_4:
      'Se você enviar ou solicitar dinheiro através da SHOPPAY Serviço de recolher o seu nome, endereço, número de telefone, dados pessoais, como receber dinheiro de suas informações de conta financeira do participante enviar o dinheiro para você.',
    summary4_5:
      'O escopo dos dados pessoais solicitados em relação aos participantes pode variar, dependendo do serviço utilizado para enviar ou solicitar dinheiro.',
    summary5_1:
      'Pagamento por outras pessoas em vez de contas ou projeto de lei solicitando pagamento para outra pessoa',
    summary5_2:
      'Se você usar o serviço SHOPPAY para pedir-lhes para pagar a conta em nome de outra pessoa, ou pagar suas contas em seu nome para outro usuário, o nome do usuário, endereço, número de telefone, endereço de email, faturamento usuário em vez de contas ou outros o proprietário da conta deve recolher dados pessoais relevantes, incluindo número da conta que você deseja pagar em seu lugar.',
    summary6_1: 'Colocar mais dinheiro na sua conta',
    summary6_1_1: 'A sua conta',
    summary6_2:
      'A fim de juntar dinheiro para outras contas na conta do usuário ou o usuário pode possuir, ou se você usar o serviço SHOPPAY a solicitação para ser adicionado ao montante nesta conta para os outros usuários do outro lado do usuário para processar eficientemente o seu pedido reunir informações ou pode coletar informações sobre você do outro lado.',
    summary6_3:
      'Por exemplo, carregar ou usar a solicitação de serviços SHOPPAY a ser adicionado ao valor na conta para um telefone celular, você pode coletar outras informações, incluindo dados pessoais e número de conta de celular dos outros participantes.',
    summary7_1: 'Informações relativas à pessoa em seus amigos e contatos',
    summary7_2:
      'Quando o usuário se conecta a lista de contatos em sua conta, é mais fácil dar ajudar as pessoas a lidar com quando SHOPPAY com seus amigos e contatos. Assim que o usuário pode utilizar o dispositivo, ou configurar uma conexão entre plataformas ou dispositivos para contas SHOPPAY ou mídias sociais de mídia social, quando conectado à plataforma melhores serviços SHOPPAY coletar e usar seus contatos informações lista (nome, endereço, endereço de e-mail, etc.) em SHOPPAY melhorar o ambiente.',
    summary8_1:
      'As informações que você optar por fornecer SHOPPAY a fim de utilizar certos serviços online ou serviços adicionais',
    summary8_2:
      'Se o pedido ou participar da seleção do site para solicitar recursos ou serviços melhorados, ou outros recursos opcionais, você pode coletar informações adicionais sobre os usuários de SHOPPAY.',
    summary8_3:
      'Se os métodos usados ​​para coletar informações a partir desses serviços diferentes daqueles declarados nesta Política de Privacidade, as informações recolhidas durante um aviso separado.',
    summary9_1:
      'Informação para o utilizador ao utilizar o serviço "SHOPPAY não pagamento"',
    summary9_2:
      'Para alguns serviços limitados podem precisar entrar ou usar as configurações da conta de não-pagamento. SHOPPAY irá recolher os seus dados pessoais, todos os métodos de pagamento informações do dispositivo relevante, dados de tecnologia, informações de localização necessárias para o usuário para completar a transação. Quando você seleciona o proprietário da conta eo pagamento para o não-negociação, você pode construir e informações de transação coleta associado à sua conta.',
    summary9_3:
      'Se o usuário enquanto não o dono da conta e selecione o pagamento para o negócio não SHOPPAY, coletar e armazenar todas as informações que você fornece são usadas e compartilhadas de acordo com a informação nesta Política de Privacidade.',
    summary10_1: 'informações específicas do usuário obtidos de terceiros',
    summary10_2:
      'De um terceiro, como comerciante, provedores de dados, agências de crédito, na medida permitida por lei, você pode obter as informações.',
  },
  partner: {
    be_partner: 'Torne-se um parceiro de SHOPPAY.',
    banner_text:
      'Compras provedor de plataforma, de mercado, há uma operadores de suporte de faturamento que necessitam de um provedor de serviços de pagamento pode ser um parceiro de SHOPPAY.',
    banner_btn: 'Para entrar em contato com seu gerente de conta',
    benefit: 'benefícios SHOPPAY que os parceiros têm direito',
    benefit_1: 'Integração e suporte técnico para a construção de soluções',
    benefit_2:
      'Por favor, não hesite em contactar a nossa equipe de suporte para que você possa obter ajuda na integração SHOPPAY. SHOPPAY portal desenvolvedor também pode ser usado como um recurso.',
    benefit_3: 'crescimento do negócio através de oportunidades de marketing',
    benefit_4:
      'Aproveitar as muitas oportunidades de comercialização previstas SHOPPAY pode atrair clientes potenciais.',
    traction: 'E reboque pagamentos em todo o mundo.',
    traction1:
      'parceiros SHOPPAY estão apoiando uma plataforma inovadora para uma solução suave de vendedores para SHOPPAY confiança.',
    traction_btn: 'mais Partners',
    program: 'Partner Program SHOPPAY é livre para participar.',
    program_1:
      'Por favor, preencha o formulário on-line, nós entraremos em contato em SHOPPAY.',
    program_2:
      'Por favor, descreva as soluções de negócios operacionais e em execução.',
    program_3:
      'Por favor SHOPPAY contato para discutir as mudanças necessárias.',
    program_4:
      'SHOPPAY integrar e ajudar a garantir que eles recebam SHOPPAY pagamento.',
    program_btn: 'Para entrar em contato com seu gerente de conta',
    common_qa: 'Perguntas Mais Frequentes',
    common_qa1: 'Existe algum parceiro fornecedores SHOPPAY?',
    common_qa1_text:
      'parceiro SHOPPAY é a empresa B2B (business-to-business) que oferece aos seus clientes soluções SHOPPAY. SHOPPAY está trabalhando com organizações como o carrinho de compras, empresas de hospedagem web, desenvolvedores web, provedores de logística e agência de marketing digital, gateway de pagamento.',
    common_qa2: 'Que parceiros SHOPPAY elegíveis?',
    common_qa2_text: 'Contacte o seu gestor de conta',
    common_qa2_text_2:
      'Você pode obter aconselhamento sobre as qualificações dos parceiros.',
    common_qa3: 'Nós fornecemos serviços de apoio integrados no SHOPPAY?',
    common_qa3_text:
      'Uma vez cadastrado no programa parceiro e SHOPPAY aprovação para entrar, você pode acessar as valiosas documentação e desenvolvedor fóruns integrados. Também pode obter suporte integrado para consultores para o certificado.',
    common_qa4:
      'Há também um fora de negócios da Coreia, I pode se inscrever separadamente para cada país no Programa de Parceiros?',
    common_qa4_text:
      'Depende do país que você está operando um negócio. Em SHOPPAY estão implantando representante do parceiro especializado para as necessidades regionais em vários países.',
    common_qa4_more: 'Ver Partner Program fornece nacional',
  },
  pay_main: {
    total_product: 'produto total',
    total_sum: 'agregado',
    pay_this_account: 'Definir esta conta como um método de pagamento.',
    bill_show:
      'As informações transação é apresentada da seguinte forma na especificação.',
    banner_text: 'SHOPPAY é mais seguro',
    banner_text2: 'Um pagamento rápido.',
    banner_text3:
      'Não importa onde fazer compras irá manter suas informações financeiras seguras.',
    footer_1: 'Termos e Condições',
    footer_2: 'Contrato de usuário',
    footer_3: 'política de Privacidade',
    footer_4: 'feedback',
    footer_5:
      'Notificação aos clientes: os proprietários dos meios pré-pagos de pagamento SHOPPAY ⓒ SHOPPAY não requer a aprovação da Autoridade de Supervisão Financeira da Austrália.',
    footer_6: 'Termos de Uso',
    footer_7: 'Também sugerimos para lê-lo com cuidado.',
    footer_8: 'faturamento',
    wallet: 'E-wallet gestão',
    last_name: 'sexo',
    card_number: 'Número do cartão',
    three_number: 'três dígitos',
    name: 'nome',
    pay_cocopay: 'Para pagar por SHOPPAY',
    free_shipping:
      'Se a conta SHOPPAY, você pode obter retorno livre o transporte, proteção de compra.',
    email_phone: 'E-mail ou número de telefone',
    login_error: 'Você tem assinatura problema em?',
    pay_card: 'Pagamento por cartão',
    cancel_back: 'Anular e voltar à página anterior',
  },
  site_map: {
    site_map_tip: 'Um link que irá ajudá-lo a explorar a conta SHOPPAY.',
    map_fund: 'fundos',
    map_fund_1: 'Debitado',
    map_fund_2: 'Minha capacidade de utilizar o saldo é?',
    map_fund_3: 'Enviar ou pedido de dinheiro',
    map_fund_4: 'gerenciamento de chamadas',
    map_fund_5: 'SHOPPAY meus descontos de cartão de débito',
    map_fund_6: 'Obter cartão de débito SHOPPAY',
    map_fund_7: 'Programação de cobrança SHOPPAY crédito',
    map_deal: 'acordo',
    map_deal_1: 'Ver todas as atividades de negócios',
    map_deal_2: 'visualizações actividades (incluindo equilíbrio e taxas)',
    map_deal_3: 'gráficos e tabelas Ver oferta',
    map_deal_4: 'Baixar negócio',
    map_deal_5: 'Em resposta a um pedido ou estorno',
    map_deal_6: 'IPN (notificação de pagamento instantâneo) História',
    map_profile: 'Meu perfil e configurações',
    map_profile_1: 'espelho de negócios',
    map_profile_2: 'E-mail, endereço, telefone ou atualização de senha',
    map_profile_3: 'conta bancária ou cartão de atualização',
    map_profile_4: 'Notificações de Atualizações',
    map_profile_5: 'Limites Ver Conta',
    map_profile_6: 'Gerenciamento de usuários',
    map_profile_7: 'Preferências Entrega Atualizar',
    map_support: 'apoio',
    map_support_1: 'Ir para o Centro de Resolução de Conflitos',
    map_support_2: 'Ir para Centro de Suporte',
    map_support_3: 'Fale conosco',
    map_support_4: 'informações taxa comerciante SHOPPAY',
    map_report: 'relatório',
    map_report_1: 'Relatório de configurar, gerenciar ou fazer o download',
    map_manage: 'ferramentas',
    map_manage_1: 'Ver ferramenta',
    map_manage_2: 'gestão botão SHOPPAY',
    map_manage_3: 'Gestão pagamento regular',
    map_consum: 'cliente',
    map_consum_1: 'Ver lista de convidados',
  },
  fee: {
    fee_tip: 'Simples Estrutura Fee',
    fee_banner_1:
      'Geralmente, a compra é livre e podem estar sujeitos a taxas de câmbio.',
    fee_banner_2:
      'Se as vendas não ficar com as taxas mensais SHOPPAY, ou taxas de cancelamento. Depois de cada comissão só será pago.',
    fee_h2: 'Normalmente compra é livre.',
    fee_text1:
      'As taxas para processamento de pagamentos são pagos pelo vendedor.',
    fee_text2: 'No entanto, você pode trocar taxa é aplicada.',
    fee_more: 'taxas do vendedor saber mais',
    fee_text3:
      'À venda pelo site da factura ou pagamento E-mail (de pagamento internacional taxas normais)',
    fee_text4: 'A taxa fixa com base no recebimento de chamadas',
    fee_text5: 'taxas de câmbio podem ser aplicadas adicionalmente.',
    fee_text6:
      'Por exemplo, para um recibo de pagamento da taxa fixa em dólares é de US $ 0,30 USD.',
  },
  dash: {
    more: 'mais',
    withdraw_asset: 'retirada de fundos',
    currency: 'moeda',
    quotes: 'Recibos e Orçamentos',
    last_6_months: 'Últimos 6 meses',
    make_invoice: 'geração de fatura',
    manage_invoice: 'invoice Management',
    grown_up: 'Por favor, envie a crescer o negócio para uma cotação.',
    un_paid_invocie: 'faturas pendentes',
    make_quotes: 'geração Citação',
    quotes_1: 'Um sugeriu quaisquer facturas pendentes.',
    quotes_2: 'SHOPPAY factura',
    quotes_alarm: 'lembretes de envio',
    quotes_detail: 'Mostrar mais',
    quotes_who: 'Bill: Choi, So - Jovem',
    latest_act: 'Atividade recente',
    act: 'atividade',
    received: 'Pagamento recebido',
    send: 'De Pagamento',
    act_record: 'Atividade (incluindo equilíbrio e taxas)',
    pay_person: 'pessoas biller',
    show_all: 'Ver tudo',
    tell_us: 'Por favor, diga-nos a sua opinião.',
    feed_text:
      'Por favor, tome um momento para nos dizer a sua opinião sobre a informação do mostrador recentemente concebido nesta página. Obrigado!',
    service: 'fornecer feedback',
    feed_text_back:
      'Obrigado por seus comentários! Foi assim que nosso site é útil?',
    feed_placeholder:
      'Por favor, deixe-me saber a razão pela qual eu vim hoje SHOPPAY há uma maneira melhor. Não inclua informações pessoais, tais como e-mail ou número de conta.',
    feed_p:
      'pessoal do escritório SHOPPAY e os hóspedes aos seus comentários podem ser enviados internamente, para que possa vê-lo, não deixe qualquer informação pessoal. serviços ao cliente, por favor clique aqui. de SHOPPAY',
    feed_protect: 'política de Privacidade',
    feed_law: 'Condições legais',
    feed_or: 'e',
    feed_need: 'ver',
    trade_name: 'nome de negócio',
    trade_id: 'ID negócio',
    transaction_type: 'negócio Tipo',
    trade_amount: 'pagamento',
    detail_show: 'Olhe',
  },
  shop_detail: {
    detail_info: 'Detalhes loja',
    api_signature: 'Armazenamento de chaves de assinatura',
    msg_shop_create: 'Esta loja foi registrado.',
    msg_shop_modify: 'Esta loja foi corrigido.',
  },
  merchant_account: {
    create_account: 'Gerar Conta de Liquidação',
    enroll_account: 'Conta de Liquidação de Registro',
    pls_select_account: 'Escolha Conta de Liquidação',
  },
  transaction_detail: {
    transaction_title: 'detalhes das ofertas',
    order_id: 'Loja Número de Pedido',
    pay_account_title: 'Pagamento Nome da conta',
    pay_account_number: 'Pagamento Número de Conta',
    pay_account_balance: 'O pagamento do saldo da conta',
    pay_account_selection: 'Selecione uma conta para pagar.',
    pay_account_selection_msg: 'Selecione uma conta de pagamento.',
  },
  guide: {
    guide_title_1: 'Conta bancária de Coco.',
    guide_title_2: 'Como a transferência e a remessa de Coco Bank?',
    guide_title_3:
      'Aproveite o serviço mais conveniente e seguro através da conta do Coco Bank.',
    guide_strapline_1:
      '① Contas que podem ser removidas imediatamente sem taxa',
    guide_strapline_2: '② Fácil de abrir uma conta rápida de maneira fácil',
    guide_strapline_3: 'Vestígio',
    guide_strapline_4: 'remessa',
    guide_strapline_5:
      'Contas que podem depositar os mais tipos de moedas na Coréia',
    guide_strapline_6: 'Conta segura do hacking',
    guide_strapline_7: 'Inquérito do Histórico Visual e Recibo disponível',
    guide_strapline_8:
      'Pode ser usado como uma conta de liquidação corporativa',
    guide_strapline_9:
      'Transações rápidas através de contas para transações C2C e B2C',
    guide_strapline_msg_1:
      'A transferência de conta do Coco Bank não ocorre para transferir dinheiro.',
    guide_strapline_msg_3: 'A abertura da conta do Coco Bank é de 10 segundos.',
    guide_strapline_msg_4: 'Processo complexo omitido.',
    guide_strapline_msg_5:
      'Você pode criar apenas o nome da conta para esse ativo.',
    guide_strapline_msg_6: 'Transferência via carteira',
    guide_strapline_msg_7: 'Usando o endereço da carteira',
    guide_strapline_msg_8: 'Encargos de taxa',
    guide_strapline_msg_9: 'Remessa no Coco Bank',
    guide_strapline_msg_10: 'Usando o número da conta',
    guide_strapline_msg_11: 'Taxa zero',
    guide_strapline_msg_12:
      'Muitos tipos de acumulações criptográficas estão sendo emitidos em todo o mundo. O Coco Bank está lidando com uma variedade de acumulações criptográficas para ajudar a conveniência do cliente de acordo com essas mudanças.',
    guide_strapline_msg_13:
      'A segurança é o núcleo das inclusões criptográficas. O Coco Bank acha que a segurança mais importante e os engenheiros digitais com mais de cinco anos de experiência em cada campo estabeleceram um sistema de segurança.',
    guide_strapline_msg_14:
      'Você pode consultar a transferência entre contas. A conta do Coco Bank pode verificar os bancos entre bancos ou outros bancos, como os bancos de mercado. Se necessário, você pode visitar o ponto e verificar e produzir o histórico de emissão.',
    guide_strapline_msg_15:
      'A conta do Coco Bank está ligada à conta de pagamento e liquidação do Coco Mercado. Depois de registrar a conta criptográfica alvo como uma conta de liquidação, você pode liquidar as mercadorias vendidas no mercado de coco para um criptopota.',
    guide_strapline_msg_16:
      'Taxas e atrasos ocorrem na transação entre o indivíduo através da carteira. O Coco Bank oferece remessa de conta bancária de Coco como forma de resolver isso. Experimente transações C2C e B2C sem taxa e atraso através da conta do Coco Bank.',
  },
  account_transfer: {
    transfer: 'Transferência de conta',
    transfer_list: 'histórico de transferências',
    transfer_list_title: 'Transferência de conta bancária de COCO',
    transfer_list_wallet: 'Outra transferência de carteira',
    msg_required_data: 'Por favor, indique todos os valores',
    msg_not_select_withdraw_account:
      'Por favor, selecione a conta de pagamento',
    create_transfer_title: 'Transferência de conta',
    from_account_select: 'Selecionar conta de pagamento',
    available_transfer: 'quantidades de transferência',
    to_account_input: 'Transferência de entrada do número de conta',
    to_account_confirm: 'Transferência de Verificação de Conta',
    to_account_user_name: 'Transferência de conta Nome de Membro',
    transfer_amount: 'transferência de Valor',
    delete_amount: 'correção',
    all_amount: 'CHEIA',
    description: 'explicação',
    transfer_btn: 'transferências',
    transfer_info_check: 'Verificação de informações pedido de transferência',
    from_account_number: 'Retirada Número de Conta',
    from_asset_title: 'Ativos Conta de abstinência',
    to_account_number: 'Transferir Número de Conta',
    success_transfer: 'Transferência foi processado com êxito.',
    transfer_list_detail: 'Transferir History &',
    search_transfer_asset: 'Busca por imóvel',
    search_transfer_account: 'Busca por conta',
    reset: 'inicialização',
    search: 'recuperação',
    transfer_list_detail_tit: 'Transferir Detalhes Detalhes',
    no_transfer: 'Não há detalhes de transferência',
    msg_not_search_account:
      'número de conta não existe ou não é uma entrada válida.',
    my_account_transfer: 'transferências A minha conta',
    msg_pls_select_account: 'Depois de selecionar um ativo, pesquise na conta.',
    placeholder_amount: 'Por favor, indique o montante da transferência',
    not_search_user_name: 'Não tenho certeza nome de usuário',
    msg_select_asset_search: 'Por favor selecione uma conta',
    success_fail: 'A transferência não foi bem sucedida.',
    pls_search_asset: 'Pesquise ativos.',
    pls_search_account: 'Pesquise na sua conta.',
    pls_select_asset: 'Por favor, selecione um ativo.',
    not_exist_account: 'A conta do ativo não existe.',
    favorites: 'Favoritos',
    no_inquiry_history: 'Não há histórico de perguntas.',
    account_number_list_1: '6 meses atrás Débito não pode ser consultado.',
    account_number_list_2: 'O número máximo de visualizações é de 6 meses.',
    account_number_list_3:
      'Apresentar o resultado de transferência atual é uma página que consulta a consulta e transferência de comerciante resulta no Coco Bank. <br /> Se você quiser visualizar os resultados da transferência com outras bolsas, verifique a parte superior da [transferência de bolsa] no topo.',
    account_number_list_3_1:
      'A consulta de resultados de transferência atual é uma página para consultas dentro do Cocobank e os resultados de transferência de lojas afiliadas. <br/> Se você gostaria de verificar o resultado da transferência para sua conta SHOPPAY, verifique a [transferência de conta SHOPPAY] no topo.',
    today: 'Dia',
    one_week: '1 semana',
    one_month: '1 mês ',
    three_months: '3 meses',
    six_months: '6 meses',
    withdrawal_account_number: 'Número da conta de retirada',
    recent_order: 'Na ordem mais recente',
    past_order: 'No pedido anterior',
  },
  bank_service_center: {
    title: 'assunto',
    date: 'data',
    state: 'estado',
    enter_search_word: 'Digite os termos de pesquisa',
    list: 'lista',
  },
  service_center: {
    view_all: 'Ver Todos',
    contact_history: 'Histórico de inquérito',
    privacy_Statement: 'Política de manipulação de informações pessoais',
    would_you_agree: 'Deseja concordar com o exposto acima?',
    mobile_number: 'Número de telemóvel',
    target_of_inquiry: 'Assunto do inquérito',
    inquiry_contents: 'Conteúdos de investigação',
    please_enter_your_inquiry: 'Digite sua pergunta.',
    send: 'Enviar',
    normal_inquiries_received: 'Sua pergunta foi recebida com sucesso.',
    inquiry_history: 'Histórico de inquérito',
    pls_select_inquiry_type: 'Selecione o tipo de contato',
    pls_login_to_use_inquiry: '1, Entrar no as primeiras investigações.',
    non_member_login: 'Login não associado',
    contact_id: 'Contact ID',
    view_inquiry: 'Ver contato',
    service_center: 'atendimento ao cliente',
    inquiry_details: 'Detalhes de contato',
    msg_enter_title: 'Por favor insira um título.',
    msg_enter_your_content: 'Por favor digite suas informações.',
    msg_pls_login: 'Por favor login.',
    go_back: 'Volte',
    re_contact: 'material de contato',
    contents: 'conteúdo',
    msg_no_inquiry_history: 'Não há detalhes de contato.',
    msg_require_login_additional_authentication:
      'Você precisa estar logado ou autenticação adicional.',
    when_you_member: 'Quando um membro',
    msg_inquiry_history_can_view_after_login:
      'Os membros dos detalhes de contato podem ser vistos após o login.',
    non_member: 'Quando não-membros',
    lookup_inquiry: 'Fale Lookup',
    msg_enter_inquiry_id: 'Digite o ID do contato.',
    msg_enter_password_when_registering_your_inquiry:
      'Por favor, digite a senha que você definiu quando você chama registo.',
    frequently_asked_questions: 'Perguntas Mais Frequentes',
    msg_enter_your_password: 'Por favor insira sua senha.',
    pls_search_fap: 'Por favor, procure para perguntas.',
    msg_source_filename_none: 'Não há foto em anexo.',
    super_inquiry: 'Topo',
  },
  modal: {
    not_seeing_day: 'Não visto durante o dia',
  },
  login_guide_modal: {
    title: 'Informação',
    sub_title:
      'O sistema de login será renovado para que os membros usem a troca sem problemas.',
    content:
      '[Antes da mudança] <br/> Login de ID criado quando você se inscreve pela primeira vez <br/><br/> [Depois da mudança] <br/> Mude para o seu número de telefone atual ou login por email. <br/> <br/> Para efetuar login até que o sistema de login seja reorganizado, faça login com o ID que você criou quando se inscreveu pela primeira vez.',
  },
  affiliate: {
    affiliate_occur_list: 'Histórico de Provisão',
    affiliate_adjust_list: 'Detalhes da liquidação de provisão',
    allowance_balance_asset: 'Saldo de provisão por ativo',
    list_allowance_balance_asset: 'Lista de saldo de provisão por ativo',
    search_by_asset: 'Pesquisa por ativo',
    allowance_search: 'Pesquisa de permissão',
    generator: 'Gerador',
    beneficiary: 'Beneficiário',
    benefactor: 'Benfeitor',
    behavior_type: 'Tipo de comportamento',
    target_unique_number: 'Segmentar número único',
    date_of_occurrence: 'Data de ocorrência',
    application_policy_name: 'Nome da política do aplicativo',
    beneficiary_type: 'Tipo de beneficiário',
    benefactor_type: 'Tipo de beneficiário',
    target_amount: 'Valor alvo',
    principal_amount: 'Quantia principal',
    allowance: 'Pagamento extra',
    allowance_assets: 'Ativos de provisão',
    allowance_amount: 'Montante da provisão',
    affiliate_log: 'Composição da provisão',
    allowance_settlement: 'Liquidação de provisões',
    allowance_settlement_info: 'Informações sobre liquidação de provisões',
    name_asset_settled: 'Nome dos ativos a serem liquidados',
    balance_receive_payment: 'Saldo a ser pago',
    select_account_settled: 'Selecionar conta a ser liquidada',
    no_affiliate_log: 'Não há subsídio incorrido.',
    no_affiliate_balance: 'Não há lista de saldos de provisão por ativo.',
    no_affiliate_adjust: 'Não há histórico de pagamentos de provisões.',
    asset_name: 'Nome do ativo',
    asset_code: 'Código do ativo',
    balance: 'Saldo',
    cumulative_amount: 'Montante acumulado',
    please_select_account: 'Por favor selecione uma conta',
    calculate: 'calcular',
    settle: 'Resolver',
    calculate_amount: 'Montante da liquidação',
    account_number: 'Número da conta',
    registration_date: 'Data de registro',
    number: 'número',
  },
  coin_name: 'Nome da moeda',
  main_function: 'Função principal',
  disclosure_ing: 'No decurso do',
  quick_service: 'serviço rápido',
  new_account: 'nova conta',
  social_login: 'nome de usuário social',
  way_to_find: 'a forma de o encontrar',
  cocobank_korea_head_office: 'Sede da SHOPPAY na Coreia',
  cocobank_branch_office: 'Sucursal da SHOPPAY Shinsa',
  address_head_office: '528 Eonju-ro, Gangnam-gu, Seul',
  address_branch_office: '803 Nonhyeon-ro, Gangnam-gu, Seul',
  map: 'mapa',
  korean_language_counseling: 'Orientação da Coreia, da Língua',
  hours_of_business:
    '10 de 19:00h no ( com exclusão de feriados bancários ) a Coreia.',
  overseas_consultation: 'consulta no exterior',
  email_consultation: 'Consulta por Email',

  exchange_price: 'sobrecapacidade exchange/price',
  market_price_check: 'preço de mercado',
  full_account_inquiry: 'de inquérito, a conta',
  exchange_details_check: 'detalhes ... de moedas checa',
  cryptocurrency_exchange_history: 'Histórico de câmbio',
  deposit_account_inquiry: 'de inquérito, número da conta depósito Fund ',
  transfer_result_check: 'ver o resultado de',
  dormant_account_check: 'cheque Dormente em',
  account_and_other_case_status: 'conta só SHOPPAY e outro estatuto de caso ',
  account_and_other_wallet: 'Conta SHOPPAY e outras consultas de carteira',
  account_search: 'Pesquisa de conta SHOPPAY',
  other_wallet_search: 'outra transferência de carteira',
  error_remittance: 'A aprovação de voltar a dispensa de SHOPPAY ',
  transfer: 'Transfer',
  other_wallets_transfer: 'em outros wallets/transfer resultados ',
  other_wallets_transfer_search: 'Lookups de outra transferência de bolsa',
  frequently_used_accounts:
    'Register/manage, utilizados frequentemente as contas',
  new_demand_account: 'Nova conta a procura',
  new_installment_savings_account: 'New installment savings account',
  new_deposit_account: 'uma nova parcela de administração',
  check_account_progress_account:
    'Verifique o estatuto de novos progressos em conta a conta.',
  download: 'baixar',
  withdrawal: 'Retirada',
  Smart_window_withdrawal: 'retirada da janela -',
  smart_ATM_withdrawal: 'retirada Smart do caixa eletrônico',
  customer_service: 'Serviço de Clientes',
  notice: 'Aviso',
  one_one_inquiry: '1 : 1 inquérito',
  inquiry_details: 'detalhes Inquérito',
  frequently_asked_questions: 'Perguntas Mais Frequentes',
  server_notice: 'aviso do Servidor',

  service_hours: 'Tempo de operação de serviço de satisfação do cliente',
  all_day_long: '(24 horas de consulta)',
  online_service_hours: 'Tempo de uso on-line Cocobank',
  unusable_hours: '24 horas, 7 dias por semana (23: 30-24: 00 Não disponível)',
  offline_hours: 'Horário bancário offline',
  offline_bank_hours: '(exceto fim de semana e feriados)',

  management: 'gestão',
  secure_management: 'Protejam Authentication/Management',
  fund_limit_management: 'de gestão de limite de Fund',
  issue_details_check: 'cheque os detalhes )',
  part_of_news: 'Esta é a parte da notícia.',
  part_of_notice: 'Esta é a parte do anúncio.',
  full_menu: 'Menu completo',
  individual: 'Individual',
  key_coin: 'Moeda chave do SHOPPAY que conecta criptomoeda à moeda real',
  limitation_info:
    'Informações sobre restrições de limite para evitar danos à fraude financeira de telecomunicações',
  limitation_info_1:
    'Devido à abertura de conta não face a face, o limite de saque (transferência) por meio de dispositivos automatizados e pela Internet é limitado a {0} CCF por dia.',
  limitation_info_2:
    'Os dados de autenticação objetiva para confirmar o propósito da transação podem ser apresentados à agência e o limite pode ser levantado em “Gerenciamento> Autenticação / Gerenciamento de Segurança”.',
  limitation_info_3:
    'Ao usar o Internet banking, você deve se registrar com uma conta de saque para fazer uma transação de transferência.',
  limitation_info_4:
    'Apenas 5 contas podem ser abertas por limite de criptomoeda.',
  limitation_notice: 'Aviso prévio',
  limitation_notice_1:
    'A assinatura de Internet banking pode ser aplicada vinculando-se a partir da tela de conclusão, após a abertura de uma conta de depósito e retirada.',
  limitation_notice_2:
    'Observe que os clientes existentes de serviços bancários pela Internet podem registrar-se para contas de saque por meio de banco pela Internet apenas quando a categoria de registro da conta de saque for Internet + agência.',
  limitation_notice_3:
    'Você deve ser uma autenticação segura para garantir que você seja mais fácil realizar sua transferência para o Internet Banking. Após o processo de certificação, por favor, melhore a classificação e prossiga com a contabilidade e arranjo do sistema de contabilidade.',
  new_subscription: 'Novo registro',
  new_subscription1_1:
    'Ao clicar no novo botão de inscrição, você receberá sua própria conta ',
  new_subscription1_2:
    'SHOPPAY e endereço de depósito vinculado à carteira externa.',
  new_subscription2_1:
    'Certifique-se de saber antes de depositar! Não há taxas se você transferir dinheiro de uma conta dedicada ao SHOPPAY para sua conta. Apenas ',
  new_subscription2_2:
    'pode ser depositado na conta / endereço emitido no novo registro. Quaisquer erros / perdas que possam ocorrer se você tentar depositar outros ativos digitais no endereço são irrecuperáveis. Após a ocorrência de 1 confirmação, ela é refletida no saldo por meio do processo de depósito. O processo de depósito é automático e o tempo necessário pode variar dependendo das condições da rede. O endereço acima é apenas para depósito.',
  new_subscription3_1: 'Você pode depositar',
  new_subscription3_2: 'com uma nova assinatura atribuída a você.',
  new_subscription4: 'Você concordou e entendeu o acima?',

  created_account_number: 'Número da conta criada',
  cocobank_exclusive_account: 'SHOPPAY Número de conta dedicado',
  depositing_external_wallet: 'Ao depositar SHOPPAY de uma carteira externa',
  use: 'Usar',
  we_future: 'nosso futuro',
  pop_cocobank: 'SHOPPAY',
  fourth_industry: 'Líder na quarta indústria',
  oc_15: '15 de outubro',
  officially_open: 'Oficialmente aberto!',
  head_branch_office:
    'Sede na Coreia (Filial Jamsil) / 1ª Filial (Filial Sinsa)',
  sep_15: '15 de setembro às 17h',
  open_popup: 'Abrir',
  thanks_for: 'Obrigado pelo seu encorajamento.',

  direct_exchange: {
    sell_buy_assets: 'Ativos a serem vendidos e comprados',
    replace_assets: 'Ativo a ser substituído',
    ccm_exchange_rate: 'CCM com taxa de câmbio preferencial',
    buy_sell_percent: 'Compre -10% Venda + 10%',
    expected_property: 'Propriedade esperada',
    preferential_property: 'Ativos preferidos',
  },

  event_banner: {
    clap:
      'Mantenha a acomodação de criptografia com COCO BANCO <span class="color-common">CLAP</span>.',
    month_hotcoupon: 'Confira o cupom HOT deste mês.',
    hotcoupon_sub: 'De taxas de câmbio a vários cupons de afiliados!',
    grab_bug: 'Pegue o bug',
    grab_bug_sub:
      'Por favor, deixe um inquérito 1: 1. Os prêmios são dados por sorteio',
    event2_sub_title: 'Taxas mais altas.<br>Retornos ainda maiores.',
    event2_title: '',
    event2_text: 'Torne-se um membro do CCM e receba um dividendo!',
    event2_btn: 'inscrever-se',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: 'fechar',
    notice_today: 'Não vendo hoje',
  },
  clap: {
    getting_started_clap: 'Método de configuração inicial',
    how_to_initialize_clap: 'Como reiniciar',
    getting_started_ledger_live: 'Como configurar o Ledger Live',
    install_coin_app: 'Ligação de app de moedas',
    start_text_1:
      '1. Depois de conectar o CLAP e o conector USB incluído ao computador, verifique a frase "Bem-vindo" para confirmar que é um novo produto.',
    start_text_2:
      '2. Pressione o botão direito e quando a mensagem "Configurar como novo dispositivo" aparecer, pressione os dois botões na parte superior ao mesmo tempo.',
    start_text_3:
      '3. Após confirmar a frase “Escolha o código PIN”, uma tela para inserir um código PIN de 8 dígitos aparecerá. Pressione os dois botões para definir o código PIN.',
    start_text_4:
      '4. Quando a configuração do código PIN for concluída, a mensagem Confirmar código PIN será exibida. Insira o código PIN novamente pressionando ambos os botões.',
    start_text_5:
      '5. Quando a configuração do código PIN for concluída, pressione o botão direito para exibir a primeira frase de 24 frases. Escreva o código no verso do Cartão de Restauração Importante de acordo com o número na tela.',
    start_text_6:
      '6. Quando a escrita estiver concluída, digite os códigos de restauração de 1 a 24 que correspondem aos números um a um.',
    start_text_7:
      '7. Quando a mensagem Pressione os dois botões para continuar for exibida, pressione os dois botões na parte superior para continuar.',
    init_text_1:
      '1. Antes de inicializar, verifique primeiro se você possui um cartão de recuperação importante e um código de recuperação.',
    init_text_2:
      '2. Existem duas maneiras de inicializar. Primeiro, se o CLAP estiver conectado ao PC e o código PIN estiver incorreto 3 vezes consecutivas, ele será inicializado automaticamente.',
    init_text_3:
      '3. Em segundo lugar, conecte o CLAP ao PC e digite o código PIN para desbloquear. Em seguida, vá para Configurações> Segurança> Redefinir tudo em ordem.',
    init_text_4:
      '4. Pressione Reset All novamente entre Cancel e Reset All para continuar com a inicialização.',
    init_text_5: '5. Insira o código PIN para concluir a inicialização.',
    init_text_6: '6. A inicialização está concluída.',
    ledger_live_text_1:
      '1. Digite start.ledgerwallet.com na barra de endereços da Internet.',
    ledger_live_text_2:
      '2. Clique no aplicativo Ledger Live na Etapa 1 para instalar o aplicativo para seu celular ou PC.',
    ledger_live_text_3:
      '3. Quando a mensagem Bem-vindo ao Ledger Live aparecer, clique em Primeiros passos para continuar.',
    ledger_live_text_4:
      '4. Serão apresentadas 4 opções. Se você está comprando um novo CLAP e dando continuidade a ele, pode selecionar o nº 1 e os outros podem ser selecionados de acordo com sua situação.',
    ledger_live_text_5:
      '5. Pressione 3 quando a configuração inicial for concluída para continuar.',
    ledger_live_text_6:
      '6. Selecione o Ledger Nano S entre as três opções e pressione continuar.',
    ledger_live_text_7:
      '7. Existem três listas de verificação. Defina-o de acordo com a sua situação atual.',
    ledger_live_text_8:
      '8. Após verificar a lista de verificação, clique no terceiro Verificar agora.',
    ledger_live_text_9:
      '9. Conecte o CLAP ao computador e desbloqueie o CLAP. (Este é o processo de verificação de autenticidade)',
    ledger_live_text_10:
      '10. Se o seu dispositivo for original na terceira lista de verificação, clique em continuar no canto inferior direito.',
    ledger_live_text_11:
      '11. A página de configuração de senha é exibida. Você pode ou não definir uma senha. Se você deseja definir uma senha, clique em Continuar / Ignorar esta etapa no canto inferior direito após inseri-la.',
    ledger_live_text_12:
      '12. Clique em continuar no canto inferior direito para prosseguir.',
    ledger_live_text_13: '13. A configuração do Ledger Live está concluída.',
    coin_app_text_1:
      '1. Ligue o Ledger Live instalado anteriormente e clique em Ir para o gerenciador no centro.',
    coin_app_text_2: '2. Conecte o CLAP ao PC e insira o CÓDIGO PIN',
    coin_app_text_3:
      '3. Depois de inserir o CÓDIGO PIN, pressione os dois botões superiores ao mesmo tempo para continuar.',
    coin_app_text_4:
      '4. Encontre a criptomoeda que você tem na parte inferior e clique em Instalar à direita para fazer o link.',
    detail_to_buy: 'Detalhes e onde comprar',
    detail_content1_1:
      'A CLAP faz sentido que o portfólio de criptografia do usuário esteja configurado para garantir que o ativo seja mantido com segurança.',
    detail_content1_2:
      'A indústria financeira global está se movendo rapidamente através da descoberta e inovação de novas tecnologias. Criadas também mudaram e aplicadas de acordo com essas mudanças, e muitas empresas globais têm prestado atenção mais uma vez sobre o valor do criptoiro.',
    detail_content1_3:
      'Os usuários de longo prazo têm mais problemas sobre a segurança dos ativos devido à natureza da criptografia que é usada apenas na forma de informações sobre um computador.',
    detail_title_2: 'O serviço fornecido pela CLAP é certo.',
    detail_content2_1:
      'O Coco Bank julgou que uma softwallette que armazena chaves privadas na nuvem é vulnerável a hacks externos, e uma questão de segurança ocorrerá. Sugerimos resolver a aglomeração da carteira de solução que complementam esses problemas.',
    detail_content2_2:
      'A CLAP suporta até oito aplicativos e pode manter uma variedade de criptografados, como moedas, testa e entrevistas. Você também pode manter ativos com segurança de hacks externos porque não é uma carteira que nem sempre é conectada à Internet.',
    detail_title_3: 'Segurança',
    detail_content3_1:
      'A CLAP é uma colaboração (carteira a frio), uma colaboração com "Ledger" e colaboração com uma empresa global de solução de segurança profissional de criptografia para resolver as questões de segurança de uma parede quente (carteira quente).',
    detail_content3_2:
      'O CLAP foi aplicado por uma solução de segurança que foi construída por 130 engenheiros globais com conhecimento e experiência de segurança digital. Inserimos os últimos chips de código PIN de segurança usados ​​por passaportes e cartões de crédito para melhorar a segurança.',
    detail_content3_3:
      'Mesmo se você perder o clap, você pode manter os ativos que você possui pelo usuário através do novo dispositivo de aplainação.',
    detail_title_4: 'conveniência',
    detail_content4_1:
      'Você pode inserir a chave secreta usando dois botões localizados no topo da CLAP.',
    detail_content4_2:
      'Apoiamos mais de 40 criptografados, incluindo Bitcoin, Ethereum e XRP e considerando a conveniência do usuário.',
    detail_title_6: 'COMO',
    detail_content6_1:
      'A / S para dispositivos de produtos é um ano a partir da data da compra.',
    detail_content6_2:
      'Se A / S for necessário, visite o Coco Bank com o corpo de aplauso.',
    detail_content6_3:
      'Um número de série anexado à parte de trás do clap para A / S é necessário. A / s não pode ser usado para minar ou remover o número de série.',
    detail_content6_4:
      'A / S pode não ser possível, dependendo do produto do produto causado pelo seu descuido e pelo estado do produto.',
    detail_title_7: 'Perceber',
    detail_content7_1:
      'Os serviços on-line de Clap não estão relacionados ao Coco Bank porque são servidos pelo razão.',
    detail_content7_2:
      'Se você usar o produto, observe que a questão do hacking do exterior causada pelo problema de hacking externo causada pelo descuidado (perda, restauração e conectar o código PIN ao PC infectado) não é responsável pelo Coco Bank.',
    detail_content7_3:
      'Os serviços on-line fornecidos por "Ledger Live" ou Ledger são irrelevantes para o dinheiro que o usuário obtido pelo usuário é irrelevante para o Banco Coco.',
    detail_title_8: 'Comprar',
    detail_content8_1: 'Co.u co.u (Café): 430 1º andar',
    detail_title_9: 'Recepção A / S',
    detail_content9_1: 'Coco Bank: Seul, Gangnam-Gu, Seul 528 2º andar',
    detail_content9_2:
      'Por favor, sinta-se à vontade para nos contatar com o Kozuko Koh mais próximo ou help@cocobank.com.',
  },
}
